import { useEffect } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { getOfflineRequests, removeOfflineRequest } from "../lib/offlineQueue";
import { useProspects } from "../context/ProspectsContext";

export function OfflineSyncManager() {
  const { fetchProspects } = useProspects();

  useEffect(() => {
    const handleOnline = async () => {
      const requests = await getOfflineRequests();
      if (!requests || requests.length === 0) return;

      toast.info(`Menyinkronkan ${requests.length} data offline...`);

      let successCount = 0;
      let errorCount = 0;

      for (const req of requests) {
        try {
          let photoUrl = null;
          // Upload evidence first if file exists
          if (req.file) {
            const fd = new FormData();
            fd.append("file", req.file, "bukti.jpg");
            const upRes = await api.post("/evidence/upload", fd, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            photoUrl = upRes.data.url;
          }

          // Post main payload
          const payload = { ...req.payload };
          if (photoUrl) {
            payload.photo = photoUrl;
          }

          await api.post(req.endpoint, payload);
          await removeOfflineRequest(req.id);
          successCount++;
        } catch (err) {
          console.error("Sync error:", err);
          errorCount++;
        }
      }

      if (successCount > 0) {
        toast.success(`${successCount} data offline berhasil disinkronkan.`);
        // Refresh contexts to get new data
        if (fetchProspects) fetchProspects();
      }
      if (errorCount > 0) {
        toast.error(`Gagal menyinkronkan ${errorCount} data offline.`);
      }
    };

    window.addEventListener("online", handleOnline);
    return () => window.removeEventListener("online", handleOnline);
  }, [fetchProspects]);

  return null; // Component ini hanya untuk background logic
}
